// reducers/religionReducer.js
export const religionReducer = (
  state = { religions: [], pending: [], rejected: [] },
  action,
) => {
  switch (action.type) {
    case "ALL_RELIGIONS_REQUEST":
    case "PENDING_RELIGIONS_REQUEST":
    case "CREATE_RELIGION_REQUEST":
    case "UPDATE_RELIGION_REQUEST":
    case "DELETE_RELIGION_REQUEST":
      return { ...state, loading: true };

    case "ALL_RELIGIONS_SUCCESS":
      return { ...state, loading: false, religions: action.payload || [] };

    case "PENDING_RELIGIONS_SUCCESS":
      return { ...state, loading: false, pending: action.payload || [] };

    case "REJECTED_RELIGIONS_SUCCESS":
      return { ...state, rejected: action.payload || [] };

    case "CREATE_RELIGION_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        religions: [...state.religions, action.payload],
      };

    // A new value typed on the Add Staff/Student form — goes to "pending".
    case "SUGGEST_RELIGION_SUCCESS":
      return { ...state, success: true };

    case "APPROVE_RELIGION_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        religions: [...state.religions, action.payload].sort((a, b) =>
          a.name.localeCompare(b.name),
        ),
      };

    case "REJECT_RELIGION_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        rejected: [...state.rejected, action.payload],
      };

    case "RESUBMIT_RELIGION_SUCCESS":
      return {
        ...state,
        rejected: state.rejected.filter((d) => d.id !== action.payload.id),
        pending: [...state.pending, action.payload],
      };

    case "UPDATE_RELIGION_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        religions: state.religions.map((d) =>
          d.id === action.payload.id ? action.payload : d,
        ),
      };

    case "DELETE_RELIGION_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        religions: state.religions.filter((d) => d.id !== action.payload),
        pending: state.pending.filter((d) => d.id !== action.payload),
        rejected: state.rejected.filter((d) => d.id !== action.payload),
      };

    case "ALL_RELIGIONS_FAIL":
    case "PENDING_RELIGIONS_FAIL":
    case "REJECTED_RELIGIONS_FAIL":
    case "CREATE_RELIGION_FAIL":
    case "SUGGEST_RELIGION_FAIL":
    case "APPROVE_RELIGION_FAIL":
    case "REJECT_RELIGION_FAIL":
    case "RESUBMIT_RELIGION_FAIL":
    case "UPDATE_RELIGION_FAIL":
    case "DELETE_RELIGION_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
